import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import MapPropTypes from '../../MapPropTypes';
import selectors from '../../../selectors';
import CartActions from '../../../actions/cart';
import UiActions from '../../../actions/ui';
import HelpActions from '../../../actions/help';
import OrderActions from '../../../actions/order';
import strings from '../../../strings';
import ModalBase from '../Base';
import Summary from './Summary';
import Progress from './Progress';
import './CheckoutModal.scss';

class CheckoutModal extends Component {
    static propTypes = {
        // functions
        close: PropTypes.func.isRequired,
        submitOrder: PropTypes.func.isRequired,
        finishOrder: PropTypes.func.isRequired,
        openHelpModal: PropTypes.func.isRequired,
        updateInstructions: PropTypes.func.isRequired,
        onEditCartChange: PropTypes.func,
        // data
        cart: PropTypes.arrayOf(
            PropTypes.shape({
                item: MapPropTypes.CartItemProps,
                product: MapPropTypes.PricingProps,
            })
        ).isRequired,
        cartTotal: PropTypes.number.isRequired,
        offer: MapPropTypes.OfferProps,
        orderStarted: PropTypes.bool.isRequired,
        orderComplete: PropTypes.bool.isRequired,
        orderIsSuccessful: PropTypes.bool.isRequired,
        orderInProgress: PropTypes.bool.isRequired,
        orderFailed: PropTypes.bool.isRequired,
        visible: PropTypes.bool.isRequired,
        history: PropTypes.object,
        isSucessful: PropTypes.bool,
        soldTo: PropTypes.string,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            cart: selectors.cart.getCartContents,
            soldTo: selectors.cart.getSoldTo,
            cartTotal: selectors.cart.getTotal,
            offer: selectors.offer.getSelectedOffer,
            orderStarted: selectors.order.orderStarted,
            orderComplete: selectors.order.orderIsComplete,
            orderIsSuccessful: selectors.order.orderIsSuccessful,
            orderInProgress: selectors.order.orderInProgress,
            orderFailed: selectors.order.orderFailed,
            visible: selectors.ui.getCheckoutModalVisible,
        });

    static mapDispatch = (dispatch) => ({
        close: () => dispatch(UiActions.closeCheckoutModal()),
        submitOrder: () => dispatch(OrderActions.submitOrder()),
        finishOrder: (history) => dispatch(UiActions.finishOrder(history)),
        openHelpModal: () => {
            dispatch(HelpActions.showContactTab());
            dispatch(
                HelpActions.updateContactSubjectIndex(
                    HelpActions.contactSubjects.indexOf('Support Inquiry')
                )
            );
            dispatch(UiActions.closeCheckoutModal());
            dispatch(UiActions.openHelpModal());
        },
        updateInstructions: (instructions) =>
            dispatch(CartActions.updateCartInstructions(instructions)),
    });

    _handleCloseClick() {
        // action order matter here, since this.props.close() will reset
        // this.props.orderIsSuccessful, making it so that this.props.finishOrder
        // is never called.
        if (this.props.orderIsSuccessful) {
            this.props.finishOrder(this.props.history);
        }
        this.props.close();
        this.props.onEditCartChange(false);
    }

    _handlePrintClick() {
        this.props.finishOrder(this.props.history);
        this.props.onEditCartChange(false);
        // if we print() right away, then we get a nice printout of the modal.
        // so we'll wait for the page to re-render before printing.
        // secret bonus: after an order, the user can print a receipt from the /order
        // or /checkout screens *at any time*. we store the last transaction made
        // in our redux store. it's used to fill out the receipt.
        setTimeout(() => window.print(), 250);
        
    }

    _handleInstructionsUpdate(event) {
        this.props.updateInstructions(event.target.value);
    }

    _closeButtonClass() {
        if (this.props.orderFailed) {
            return 'btn-danger';
        }
        if (this.props.isSucessful) {
            return 'btn-success';
        }
        return 'btn-warning';
    }

    _renderContent() {
        //console.log('sold to in checkout model=', this.props.soldTo)
        if (this.props.orderStarted) {
            return (
                <Progress
                    complete={this.props.orderComplete}
                    failed={this.props.orderFailed}
                    isSuccessful={this.props.orderIsSuccessful}
                    openHelp={() => this.props.openHelpModal()}
                />
            );
        }

        return (
            <Summary
                cart={this.props.cart}
                cartTotal={this.props.cartTotal}
                offer={this.props.offer}
                onUpdateInstructions={(e) => this._handleInstructionsUpdate(e)}
                soldTo={this.props.soldTo}
            />
        );
    }

    render() {
        if (!this.props.offer) {
            return <span />;
        }

        const actionButton = this.props.orderComplete ? (
            <button
                className="btn btn-info"
                onClick={() => this._handlePrintClick()}
            >
                {strings.printReceipt}
            </button>
        ) : (
            <button
                className="btn btn-success"
                onClick={() => this.props.submitOrder()}
                disabled={this.props.orderInProgress}
            >
                {strings.submitOrder}
            </button>
        );

        return (
            <ModalBase
                modalClassName="checkout-modal"
                modalTitle={
                    this.props.orderComplete
                        ? strings.orderSubmitted
                        : strings.submitOrderQuestion
                }
                visible={this.props.visible}
                backdrop="static"
                closeModal={() => this._handleCloseClick()}
            >
                {this._renderContent()}
                <div className="text-right">
                    <button
                        className={`btn ${this._closeButtonClass()}`}
                        onClick={() => this._handleCloseClick()}
                        disabled={this.props.orderInProgress}
                    >
                        {this.props.orderComplete
                            ? strings.close
                            : strings.cancel}
                    </button>
                    &nbsp;
                    {actionButton}
                </div>
            </ModalBase>
        );
    }
}

export default withRouter(attach(CheckoutModal));



// WEBPACK FOOTER //
// ./app/components/Modals/CheckoutModal/index.jsx